<template>
  <el-dialog
    :visible.sync="isShow"
    width="800px"
    class="linkAllDialog"
    :title="title"
    :close-on-click-modal="false"
    :show-close="!saving"
    top="12vh">
    <div class="sss" style="height: 530px;padding-bottom: 25px">
      <template v-if="type==='player'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty"></yioks-empty>
          <div v-else class="infinite-list-wrapper" style="overflow:auto;height: 500px">
            <div class="th" style="margin-right: 20px">
              <div class="tr name" style="border-left: 1px solid gray">
                <p>姓名</p>
              </div>
              <div class="tr organName">
                <p>当前培训协会</p>
              </div>
              <div class="tr youthName">
                <p>当前培训机构</p>
              </div>
              <div class="tr idNumber">
                <p>身份证号</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <ul
              v-infinite-scroll="load"
              class="list"
              style="margin-right: 20px"
              :infinite-scroll-immediate="false"
              :infinite-scroll-disabled="disabled">
              <li v-for="(item,index) in linkList" :key="item.id" class="tbody">
                <div class="td name" style="border-left: 1px solid gray">
                  <p>{{item.idName}}</p>
                </div>
                <div class="td organName">
                  <p>{{item.organShortName}}</p>
                </div>
                <div class="td youthName">
                  <p>{{item.youthShortName}}</p>
                </div>
                <div class="td idNumber">
                  <p>{{item.idNumber | filterIdNumberPrivacy}}</p>
                </div>
                <div class="td choose" >
                  <el-button
                    v-if="item.checked"
                    type="danger"
                    size="small"
                    style="background-color: #f56c6c"
                    icon="el-icon-remove-outline"
                    @click="remove(index)">取消</el-button>
                  <el-button
                    v-else
                    type="primary"
                    size="small"
                    icon="el-icon-circle-plus-outline"
                    @click="add(index)">关联</el-button>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px">
              <p>已关联{{Object.keys(linkObj).length}}人</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='event'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty"></yioks-empty>
          <div v-else class="infinite-list-wrapper" style="overflow:auto;height: 500px">
            <div class="th" style="margin-right: 20px">
              <div class="tr name" style="border-left: 1px solid gray">
                <p>训练计划</p>
              </div>
              <div class="tr organName">
                <p>球队名字</p>
              </div>
              <div class="tr youthName">
                <p>主教练</p>
              </div>
              <div class="tr idNumber">
                <p>开始时间</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <ul
              v-infinite-scroll="load"
              :infinite-scroll-immediate="false"
              class="list"
              style="margin-right: 20px"
              :infinite-scroll-disabled="disabled">
              <li v-for="(item,index) in linkList" :key="item.id" class="tbody">
                <div class="td name" style="border-left: 1px solid gray">
                  <p>{{item.trainingName}}</p>
                </div>
                <div class="td organName">
                  <p>{{item.squadName}}</p>
                </div>
                <div class="td youthName">
                  <p>{{item.chiefCoachName}}</p>
                </div>
                <div class="td idNumber">
                  <p>{{item.trainingTime | time}}</p>
                </div>
                <div class="td choose" >
                  <el-button
                    v-if="item.checked"
                    type="danger"
                    size="small"
                    style="background-color: #f56c6c"
                    icon="el-icon-remove-outline"
                    @click="remove(index)">取消</el-button>
                  <el-button
                    v-else
                    type="primary"
                    size="small"
                    icon="el-icon-circle-plus-outline"
                    @click="add(index)">关联</el-button>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px">
              <p>已关联{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='matchReport'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty"></yioks-empty>
          <div v-else class="infinite-list-wrapper" style="overflow:auto;height: 500px">
            <div class="th" style="margin-right: 20px">
              <div class="tr name" style="border-left: 1px solid gray">
                <p>比赛报告</p>
              </div>
              <div class="tr organName">
                <p>球队名字</p>
              </div>
              <div class="tr youthName">
                <p>主教练</p>
              </div>
              <div class="tr idNumber">
                <p>开始时间</p>
              </div>
              <div class="tr choose" >
                <p>操作</p>
              </div>
            </div>
            <ul
              v-infinite-scroll="load"
              :infinite-scroll-immediate="false"
              class="list"
              style="margin-right: 20px"
              :infinite-scroll-disabled="disabled">
              <li v-for="(item,index) in linkList" :key="item.id" class="tbody">
                <div class="td name" style="border-left: 1px solid gray">
                  <p>{{item.trainingName}}</p>
                </div>
                <div class="td organName">
                  <p>{{item.squadName}}</p>
                </div>
                <div class="td youthName">
                  <p>{{item.chiefCoachName}}</p>
                </div>
                <div class="td idNumber">
                  <p>{{item.trainingTime | time}}</p>
                </div>
                <div class="td choose" >
                  <el-button
                    v-if="item.checked"
                    type="danger"
                    size="small"
                    style="background-color: #f56c6c"
                    icon="el-icon-remove-outline"
                    @click="remove(index)">取消</el-button>
                  <el-button
                    v-else
                    type="primary"
                    size="small"
                    icon="el-icon-circle-plus-outline"
                    @click="add(index)">关联</el-button>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px">
              <p>已关联{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='plan'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true"></yioks-empty>
          <div v-else class="infinite-list-wrapper tutorial" style="overflow:auto;height: 500px">
            <ul
              v-infinite-scroll="load"
              :infinite-scroll-immediate="false"
              class="list"
              style="margin-right: 20px"
              :infinite-scroll-disabled="disabled">
              <li v-for="(item,index) in linkList" :key="item.id" class="item" >
                <div class="title">{{item.title}}</div>
                <div class="info_content">
                  <img :src="item.coverImgUrl" alt="" @error="item.coverImgUrl = placeHolderImg">
                  <div class="info">
                    <p>作者：{{item.authorName}}</p>
                    <p>分类：{{item.categoryZh}}</p>
                    <p>语言：{{item.language === 'zh' ? '中文' : '英文'}}</p>
                    <p>技术等级：{{item.skillLevelZh}}</p>
                  </div>
                  <div class="btn_wrap">
                    <p>最后更新时间：{{item.updatedAt | time}}</p>
                    <div class="btn">
                      <el-button
                        v-if="item.checked"
                        type="danger"
                        style="background-color: #f56c6c"
                        icon="el-icon-remove-outline"
                        @click="remove(index)">取消</el-button>
                      <el-button
                        v-else
                        type="primary"
                        icon="el-icon-circle-plus-outline"
                        @click="add(index)">关联</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px">
              <p>已关联{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="isShow=false">保存</el-button>
            </div>
          </template>
        </template>
      </template>
      <template v-if="type==='media'">
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true"></yioks-empty>
          <div v-else class="infinite-list-wrapper tutorial" style="overflow:auto;height: 500px">
            <ul
              v-infinite-scroll="load"
              :infinite-scroll-immediate="false"
              class="list"
              style="margin-right: 20px"
              :infinite-scroll-disabled="disabled">
              <li v-for="(item,index) in linkList" :key="item.id" class="item" >
                <div class="title">{{item.title}}</div>
                <div class="info_content">
                  <img :src="item.videoCoverAddress" alt="" @error="item.placeHolderImg = placeHolderImg">
                  <div class="info">
                    <p>标题：{{item.videoTitle}}</p>
                    <p>上传人：{{item.authorName}}</p>
                    <p>时长：{{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
                    <p>描述：{{item.videoIntro|| '--'}}</p>
                  </div>
                  <div class="btn_wrap" style="margin-right: 0">
                    <div class="btn">
                      <el-button
                        v-if="item.checked"
                        type="danger"
                        style="background-color: #f56c6c"
                        icon="el-icon-remove-outline"
                        @click="remove(index)">取消</el-button>
                      <el-button
                        v-else
                        type="primary"
                        icon="el-icon-circle-plus-outline"
                        @click="add(index)">选择</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px">
              <p>已选择{{Object.keys(linkObj).length}}个</p>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 15px"
                @click="save">保存</el-button>
            </div>
          </template>
        </template>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import player from '@/api/player'
import training from '@/api/training'
import teaching from '@/api/teaching'
import tutorial from '@/api/tutorial'
import media from '@/api/media'
import placeHolderImg from '@/assets/images/common/plan_default.png'
export default {
  name: 'index',
  components: {

  },
  props: {
    type: {
      required: true, // 传入类型
      type: String
    },
    obj: {
      required: false, // 用来判断回显选中的
      type: Object
    },
    objectUuid: {
      required: true,
      type: String
    },
    organUuid: {
      required: true,
      type: String
    },
    youthUuid: {
      required: true,
      type: String
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    mediaType: {
      type: String,
      default: 'player'
    }
  },
  data () {
    return {
      placeHolderImg,
      ops,
      count: 0,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      linkList: [ ],
      linkObj: { },
      page: 0,
      pageSize: 20,
      loading: true,
      empty: false,
      total: 0,
      disabled: false,
      saving: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.showDialog
      },
      set (val) {
        this.$emit('update:showDialog', val)
      }
    }
  },
  created () {
    if (Object.keys(this.obj).length > 0) {
      this.linkObj = { ...this.linkObj, ...this.obj }
    }
    if (this.type === 'media') {
      this.getMediaList()
    } else if (this.type === 'player') {
      this.getPlayerList()
    } else if (this.type === 'event') {
      this.getTrainList()
    } else if (this.type === 'plan') {
      this.getPlanList()
    } else if (this.type === 'matchReport') {
      this.getMatchList()
    }
  },
  methods: {
    save () {
      if (this.saving) return
      this.saving = true
      const data = {
        associatedObject: this.mediaType,
        associatedObjectUuid: this.objectUuid,
        videoList: Object.keys(this.linkObj)
      }
      media.videoAssociatedCreate(data).then(res => {
        this.saving = false
        if (res.code) {
          this.$message.error(res.msg)
        } else {
          this.$emit('hideDialog', false)
        }
      }).catch(() => {
        this.saving = false
      })
    },
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getMediaList () {
      this.loading = true
      media.unAssociatedVideoList({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize,
        objectUuid: this.objectUuid
      }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.linkList = res.content
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    requestMedia () {
      media.unAssociatedVideoList({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize,
        objectUuid: this.objectUuid
      }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          this.linkList = this.linkList.concat(res.content)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestPlayer () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = player.getPlayerSystem
      } else if (this.userRole === 'organ') {
        request = player.getPlayerOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = player.getPlayerYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = player.getPlayerLeaderOrCoach
      } else if (this.userRole === 'player') {
        request = player.getPlayerByPlayer
      }
      request({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize
      }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestTrain () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = training.getTrainPlanListSystem
      } else if (this.userRole === 'organ') {
        request = training.getTrainPlanListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = training.getTrainPlanListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = training.getTrainPlanListCoach
      } else if (this.userRole === 'player') {
        request = training.getTrainPlanListPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestPlan () {
      this.loading = true
      let request = tutorial.getMyTutorial
      request({ page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    requestMatchPlan () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = teaching.getMatchTrainListSystem
      } else if (this.userRole === 'organ') {
        request = teaching.getMatchTrainListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = teaching.getMatchTrainListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = teaching.getMatchTrainListCoach
      } else if (this.userRole === 'player') {
        request = teaching.getMatchTrainListPlayer
      }
      request({ page: this.page, size: this.pageSize }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.linkList = this.linkList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    load () {
      this.page += 1
      if (this.page > Math.floor(this.total / this.pageSize)) {
        return
      }
      if (this.type === 'player') {
        this.requestPlayer()
      } else if (this.type === 'event') {
        this.requestTrain()
      } else if (this.type === 'plan') {
        this.requestPlan()
      } else if (this.type === 'matchReport') {
        this.requestMatchPlan()
      }
    },
    getPlayerList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = player.getPlayerSystem
      } else if (this.userRole === 'organ') {
        request = player.getPlayerOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = player.getPlayerYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = player.getPlayerLeaderOrCoach
      } else if (this.userRole === 'player') {
        request = player.getPlayerByPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.linkList = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getTrainList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = training.getTrainPlanListSystem
      } else if (this.userRole === 'organ') {
        request = training.getTrainPlanListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = training.getTrainPlanListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = training.getTrainPlanListCoach
      } else if (this.userRole === 'player') {
        request = training.getTrainPlanListPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          return
        }
        this.linkList = res.content.map(item => {
          if (this.linkObj[item.uuid]) {
            item.checked = true
          }
          return item
        })
        this.total = res.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    getPlanList () {
      this.loading = true
      let request = tutorial.getMyTutorial
      request({ page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          return
        }
        this.linkList = res.content.map(item => {
          if (this.linkObj[item.uuid]) {
            item.checked = true
          }
          return item
        })
        this.total = res.totalElements
      }).catch(() => {
        this.loading = false
      })
    },
    getMatchList () {
      this.loading = true
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = teaching.getMatchTrainListSystem
      } else if (this.userRole === 'organ') {
        request = teaching.getMatchTrainListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = teaching.getMatchTrainListYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = teaching.getMatchTrainListCoach
      } else if (this.userRole === 'player') {
        request = teaching.getMatchTrainListPlayer
      }
      request({ organUuid: this.organUuid, youthUuid: this.youthUuid, page: this.page, size: this.pageSize }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.linkList = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    changeBox (val, index) {
      // console.log(val,index)
      this.$set(this.linkList[index], 'checked', val)
      if (val) {
        this.linkObj[this.linkList[index].uuid] = this.type
      } else {
        delete this.linkObj[this.linkList[index].uuid]
      }
    },
    add (index) {
      this.$set(this.linkList[index], 'checked', true)
      this.linkObj[this.linkList[index].uuid] = this.type
    },
    remove (index) {
      this.$set(this.linkList[index], 'checked', false)
      delete this.linkObj[this.linkList[index].uuid]
    }
  }
}
</script>

<style  lang="stylus">
  @import '~@/assets/css/variable'
  .linkAllDialog
    .el-dialog__body
      padding  15px 20px
    .th
      display flex
      height:40px
      justify-content: center;
      align-items: center;
      border-bottom 1px solid gray
      border-top 1px solid gray
      .tr
        height 100%
        flex  1  1 auto
        border-right 1px solid gray
        display flex
        justify-content center
        align-items center
        p
          text-align center
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: black;
      .choose
        width 15%
      .name
        width 15%
      .organName
        width 20%
      .youthName
        width 20%
      .idNumber
        width 20%
      .opt
        width 15%
    .tbody
      display: flex
      justify-content center
      align-items center
      border-bottom 1px solid gray
      height 49px
      .td
        border-right 1px solid gray
        height 100%
        flex  1  1 auto
        display flex
        justify-content center
        align-items center
        p
          text-align center
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: black;
      .choose
        width 15%
      .name
        width 15%
      .organName
        width 20%
      .youthName
        width 20%
      .idNumber
        width 20%
      .opt
        width 15%
    .el-pagination
      color black
      .el-pagination__total,.el-pagination__jump
        color black
      .btn-prev,.btn-next
        color black
      ul > li
        color black
      ul > li:hover
        color $green_color
      ul > li.active
        color  $green_color
</style>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .tutorial
    color #999
    font-size 16px
    .item
      padding 10px 0
      border-bottom 1px solid #CCC
      margin 0 20px
      .title
        padding 10px 0 25px 0
        font-size 20px
        font-weight bold
        color #000
      .info_content
        display flex
        img
          width 207px
          height 121px
          margin-right 25px
        .info
          display flex
          flex-direction column
          justify-content center
          flex 1
          p
            margin-bottom 10px
        .btn_wrap
          margin-right 40px
          .btn
            margin-top 10px
            text-align center
</style>
